import { render, staticRenderFns } from "./UserAccessRequestsPage.vue?vue&type=template&id=33aa209e&scoped=true"
import script from "./UserAccessRequestsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAccessRequestsPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa209e",
  null
  
)

export default component.exports